import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export default function CashoutSuccess({ paymentProvider, onContinue }) {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div
      id="cashout-success"
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm show"
    >
      <div className="modal-backdrop fade in" />

      <div className="modal-dialog">
        <div className="modal-content modal-content-sm">
          <div className="modal-header">
            <h4>{t('cashout_success')}</h4>
            <hr />
          </div>

          <div className="modal-body">
            <div className="row">
              <p id="cashout-processor-success-text" className="col-xs-12">
                {paymentProvider === 'wire' // todo: need to refactor..
                  ? t('cashout_success_text_wire')
                  : t('cashout_success_text')}
              </p>
            </div>
          </div>

          <div className="modal-footer">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-primary btn-full"
                onClick={onContinue}
              >
                {t('cashout_ok')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CashoutSuccess.propTypes = {
  paymentProvider: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
};
